<ng-container *ngIf="underMaintance">
    <app-under-mainatance></app-under-mainatance>
</ng-container>

<ng-container *ngIf="!underMaintance">
    <router-outlet></router-outlet>
    <app-loader></app-loader>
</ng-container>